module.exports = __webpack_public_path__ + "media/images/partners/culture2025w-4eb547552810aad7cd8da131a585705a.svg";